//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name:'lama-footer',
  // data() {
  //   return {
  //     socialList: [
  //       {
  //         icon: "fa-facebook-f",
  //         url: "https://www.facebook.com/",
  //       },
  //     ],
  //   };
  // },
};
